import React, { useEffect } from 'react';
// antd
import { FileAddOutlined } from '@ant-design/icons';
// components
import ButtonSmallIcon from 'common/components/button/ButtonSmallIcon';
// redux
import { useDispatch } from 'react-redux';
import * as actions from '@redux/global/actions';
// static
import { ABILITY_ACTION, ABILITY_SUBJECT } from 'static/Permission';
// hooks
import { useCheckPermissions } from 'hooks/useCheckPermissions';

const AddSearchProductToFolder = ({ disabledFilterSearch }) => {
  const dispatch = useDispatch();

  const handleAddSearchProductToFolder = () => {
    dispatch(actions.toggleAddSearchProductToFolder());
  };

  useEffect(() => {
    dispatch(actions.updateAddSearchProductToFolder(false));
  }, [disabledFilterSearch]);

  const allowViewFolder = useCheckPermissions([
    { action: ABILITY_ACTION.VIEW, subject: ABILITY_SUBJECT.FOLDER },
  ]);

  return (
    <ButtonSmallIcon
      icon={<FileAddOutlined />}
      label={'Add Search Results to Folder'}
      className='button-item-dropdown'
      disabled={!allowViewFolder || disabledFilterSearch}
      onClick={handleAddSearchProductToFolder}
    />
  );
};

export default AddSearchProductToFolder;
